export enum InputFieldType {
    Text = 'text',
    Select = 'select',
    Masked = 'masked',
    Label = 'label'
}
